import useSWR from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const menu = (language) =>
  Manager.client().post(Endpoints.privateArea.menu_messages, {
    language,
  });

const unread = (language, card, token, csmf) =>
  Manager.client().post(Endpoints.privateArea.unread_messages, {
    language,
    card,
    csmf,
    token
  });

const messages = (language, card, token, category, archived, csmf) =>
  Manager.client().post(Endpoints.privateArea.user_messages, {
    language,
    card,
    token,
    category,
    archived,
    csmf,
  });

const message = (language, card, token, id_msg, csmf) =>
  Manager.client().post(Endpoints.privateArea.user_message, {
    language,
    card,
    token,
    id_msg,
    csmf,
  });

const setMessage = (card, token, id_msg, action, language) =>
  Manager.client().post(Endpoints.privateArea.set_message, {
    card,
    token,
    id_msg,
    action,
    language,
  });

export const UseMenuMessages = (language) => {
  const key = `${Endpoints.privateArea.menu_messages}/${language}/`;
  const { data, error } = useSWR([key, language], () => menu(language));

  return {
    data: data
      ? data.data.data.categoryInbox.inbox.map((el) => {
          return {
            ...el,
            link: el.descr_tipologia,
          };
        })
      : null,
    error,
    loading: !error && !data,
  };
};

export const UseMessagesUnreadCount = async (language, card, token,  csmf) => {
  const { data, error } = await unread(language, card, token, csmf);

  return {
    data: data ? data?.message : 0,
    error,
    loading: !error && !data,
  };
};

export const UseUserMessages = async (language, card, token, category, archived, csmf) => {
  const { data, error } = await messages(language, card, token, category, archived, csmf);

  return {
    data: data && data.data.messageInbox && data.data.messageInbox.inbox ? data.data.messageInbox.inbox.reverse() : [],
    error,
    loading: !error && !data,
  };
};

export const UseUserMessage = async (language, card, token, id_msg, csmf) => {
  const { data, error } = await message(language, card, token, id_msg, csmf);

  return {
    data: data ? data.data : [],
    error,
    loadingMessage: !error && !data,
  };
};

export const UseSetMessage = async (card, token, id_msg, action, language) => {
  const { data, error } = await setMessage(card, token, id_msg, action, language);

  return {
    data: data ? data.data : [],
    error,
    loading: !error && !data,
  };
};
